import React from 'react';

interface Trend {
  Trend?: string;
  TrendType?: 'positive' | 'negative';
}

interface NotableTrendCardProps {
  trend: Trend | string;
}

const NotableTrendCard: React.FC<NotableTrendCardProps> = ({ trend }) => {
  const getTrendBackground = () => {
    if (typeof trend === 'object' && trend.TrendType === 'positive') return '#f0fff4';
    if (typeof trend === 'object' && trend.TrendType === 'negative') return '#fff5f5';
    return '#fafafa';
  };

  return (
    <li style={{ 
      marginBottom: '0.75rem', 
      padding: '0.75rem',
      borderBottom: '1px solid #f7fafc',
      color: '#2d3748',
      lineHeight: '1.5',
      background: getTrendBackground(),
      borderRadius: '6px'
    }}>
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'space-between',
        marginBottom: typeof trend === 'object' && trend.TrendType ? '0.25rem' : '0'
      }}>
        <div style={{ fontWeight: '600', color: '#1a202c' }}>
          {typeof trend === 'string' ? trend : trend.Trend}
        </div>
        {typeof trend === 'object' && trend.TrendType && (
          <span style={{
            fontSize: '0.8rem',
            padding: '0.25rem 0.5rem',
            borderRadius: '12px',
            background: trend.TrendType === 'positive' ? '#c6f6d5' : '#fed7d7',
            color: trend.TrendType === 'positive' ? '#22543d' : '#742a2a',
            fontWeight: '500',
            width: '50px',
            minWidth: '50px',
            alignContent: 'center',
            textAlign: 'center'
          }}>
            {trend.TrendType === 'positive' ? 'Positive' : 'Negative'}
          </span>
        )}
      </div>
    </li>
  );
};

export default NotableTrendCard;
